import axios from "axios";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const COOKIE_OPTIONS = { path: "/" };

export const api = axios.create({
  headers: {
    Authorization: `Bearer ${cookies.get("access")}`,
    ...(cookies.get("distributionCenterId")
      ? { "Distribution-Center-Id": cookies.get("distributionCenterId") }
      : {})
  }
});

let isAuthError = false;

export const setDistributionCenterId = id => {
  api.defaults.headers["Distribution-Center-Id"] = id;
  cookies.set("distributionCenterId", id, COOKIE_OPTIONS);
};

const setupInterceptors = (addPopup, signOut) => {
  api.interceptors.response.use(
    response => {
      isAuthError = false;
      return response;
    },
    error => {
      if (
        error?.response?.status === 401 &&
        error?.response?.data?.detail !==
          "No active account found with the given credentials"
      ) {
        if (!isAuthError) {
          isAuthError = true;
          signOut();
          addPopup({
            type: "info",
            title: "Token expirado ou inválido."
          });
        }
      }
      return Promise.reject(error);
    }
  );
};

export default setupInterceptors;
